import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import Route from './Route'
import Login from 'presentation/pages/login'
import Home from 'presentation/pages/home'

import EmployeeForm from 'presentation/pages/employees/employeeForm'
import EmployeesImport from 'presentation/pages/employees/list/components/import'
import Recharges from 'presentation/pages/recharge/list'

import Cards from 'presentation/pages/cards'
import NewCard from 'presentation/pages/cards/newCard/newCard'
import NewCardSecond from 'presentation/pages/cards/newCardSecond/newCardSecond'
import FirstCopy from 'presentation/pages/cards/firstCopy'
import OrderPayment from 'presentation/pages/cards/orderPayment'
import { PaymentConfirmation } from 'presentation/pages/paymentConfirmation'

import Departments from 'presentation/pages/departments/list'
import DepartmentEdit from 'presentation/pages/departments//edit'

import CompanyRegistration from 'presentation/pages/company/register'
import RegistryMigration from 'presentation/pages/company/register/registryMigration'

import ImportRecharge from '@/presentation/pages/recharge/import'
import RechargeImportReview from '@/presentation/pages/recharge/import/components/rechargeImportReview'
import Financial from '@/presentation/pages/financial'
import RechargePayment from '@/presentation/pages/recharge/rechargePayment'

import Reports from 'presentation/pages/reports'
import RechargeEmployeesSelection from 'presentation/pages/recharge/manual/rechargeEmployeesSelection'
import ManualRechargeValueDefinition from 'presentation/pages/recharge/manual/manualRechargeValueDefinition'
import PasswordDefinition from 'presentation/pages/passwordDefinition'
import ForgotPassword from 'presentation/pages/forgotPassword'
import { routesNames } from './routesNames'

import Users from 'presentation/pages/users'
import BrokerOrder from 'presentation/pages/recharge/broker'
import ConfirmOrderBroker from 'presentation/pages/recharge/broker/components/confirm'
import Employees from 'presentation/pages/employees/list/employeeList'
import { Cart } from 'presentation/pages/cart/cart'
import { CartOrderConfirmation } from 'presentation/pages/cartOrderConfirmation/cartOrderConfirmation'
import { useFeatures } from 'main/hooks/useFeatures'
import { Pix } from 'presentation/pages/pix/pix'
import { OrderTracking } from 'presentation/pages/orderTracking/orderTracking'

const Routes = () => {
  const { features } = useFeatures()
  return (
    <Switch>
      <Route path='/login' component={Login} hideMenu />
      <Route path='/recarga/pix' component={Pix} exact isProtected />
      <Route path='/alterar_senha' exact component={PasswordDefinition} hideMenu />
      <Route path='/cadastro' exact={true} component={CompanyRegistration} />
      <Route path='/cadastro/migrar' exact={true} component={RegistryMigration} />
      <Route path='/cadastro/senha' exact component={PasswordDefinition} hideMenu />
      {features.cart && <Route path='/carrinho' exact component={Cart} isProtected />}
      {features.cart && <Route path='/carrinho/confirmacao' exact component={CartOrderConfirmation} isProtected />}
      <Route path='/esqueci_minha_senha' exact component={ForgotPassword} hideMenu />
      <Route path='/' exact={true} component={Home} isProtected />
      <Route path='/colaboradores' exact={true} component={Employees} isProtected />
      <Route path='/colaboradores/cadastro' exact={true} component={EmployeeForm} isProtected />
      <Route path='/colaboradores/editar' exact={true} component={EmployeeForm} isProtected />
      <Route path='/colaboradores/visualizar' exact={true} component={EmployeeForm} isProtected />
      <Route path='/colaboradores/importacao' exact={true} component={EmployeesImport} isProtected />
      <Route path='/cartoes' exact={true} component={Cards} isProtected />
      <Route path='/cartoes/acompanhamento' exact component={OrderTracking} isProtected />
      <Route path='/cartoes/novo' exact={true} component={NewCard} isProtected />
      <Route path='/cartoes/novo/primeira' exact={true} component={FirstCopy} isProtected />
      <Route path='/cartoes/novo/segunda' exact={true} component={NewCardSecond} isProtected />
      <Route path='/cartoes/novo/segunda_confirmacao' exact={true} component={PaymentConfirmation} isProtected />
      <Route path='/cartoes/novo/pagamento/segunda' exact={true} component={OrderPayment} isProtected />
      <Route path='/departamentos' exact={true} component={Departments} isProtected />
      <Route path='/departamentos/editar' exact={true} component={DepartmentEdit} isProtected />
      <Route path='/financeiro' exact={true} component={Financial} isProtected />
      <Route path='/recargas' exact={true} component={Recharges} isProtected />
      <Route path='/recargas/acompanhamento' exact component={OrderTracking} isProtected />
      <Route
        path={routesNames.recharges.new_manual_order}
        exact={true}
        component={RechargeEmployeesSelection}
        isProtected
      />
      <Route
        path={routesNames.recharges.new_manual_order_values}
        exact={true}
        component={ManualRechargeValueDefinition}
        isProtected
      />
      <Route
        path={routesNames.recharges.manual_order_confirmation}
        exact={true}
        component={PaymentConfirmation}
        isProtected
      />
      <Route
        path={routesNames.recharges.brocker_manual_order_confirmation}
        exact={true}
        component={PaymentConfirmation}
        isProtected
      />
      <Route path={routesNames.recharges.manual_order_payment} exact={true} component={RechargePayment} isProtected />
      <Route path={routesNames.recharges.new_import_order} exact={true} component={ImportRecharge} isProtected />
      <Route
        path={routesNames.recharges.new_import_order_values}
        exact={true}
        component={RechargeImportReview}
        isProtected
      />
      <Route
        path={routesNames.recharges.import_order_confirmation}
        exact={true}
        component={PaymentConfirmation}
        isProtected
      />
      <Route path={routesNames.recharges.import_order_payment} exact={true} component={RechargePayment} isProtected />
      <Route path={routesNames.recharges.broker_order_import} exact={true} component={BrokerOrder} isProtected />
      <Route
        path={routesNames.recharges.broker_order_import_confirm}
        exact={true}
        component={ConfirmOrderBroker}
        isProtected
      />

      <Route path='/relatorios' exact={true} component={Reports} isProtected />
      <Route path='/usuarios' exact={true} component={Users} isProtected />
      <Route render={() => <Redirect to='/' />} />
    </Switch>
  )
}

export default Routes
